import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import { siteConfig } from '@/mocks/site';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    email: siteConfig.contactInfo.email,
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteConfig.name} - 首页`,
    description: siteConfig.description,
    url: siteConfig.url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '年轻的岳母和年长的岳母在相处上有什么不同？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '年轻的岳母往往有更活跃的生活、更开放的心态，代沟相对较小，沟通更容易找到共同话题。但同时也可能因为年龄接近而产生角色定位模糊，需要更加注意情感边界的建立。关键在于既把她当作长辈尊重，又能像朋友一样自然相处。',
        },
      },
      {
        '@type': 'Question',
        name: '女婿应该如何称呼年轻的岳母？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '大多数情况下，叫「妈」是最合适的选择——它既表达了尊重和亲近，又避免了生疏感。关键在于观察她的反应和偏好，灵活调整。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        schema={[websiteSchema, organizationSchema, webpageSchema, faqSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}